<template>
	<div class="white pos-rel rounded-lg min-h-screen">
		<div class="header">
			<div>Transfer {{ isMojAgency ? "Cheers" : "Coins" }}</div>
		</div>
		<v-btn
			fab
			flat
			class="top-left-align pa-0 ma-0 pt-1"
			@click="closeModal"
		>
			<v-icon>close</v-icon>
		</v-btn>
		<v-container
			class="pa-4 container"
			v-if="!isUserDetailsFetched && !isMojAgency"
		>
			<v-layout class="mb-2">
				<v-flex class="text-field-wrapper py-1 px-1 mx-0">
					<MazPhoneNumberInput
						v-model="phone"
						required
						default-country-code="IN"
						@update="updatePhoneNo"
						show-code-on-list
					/>
				</v-flex>
			</v-layout>
			<v-layout class="d-flex justify-space-between">
				<v-btn
					class="mx-0 mr-4 white--text btn"
					:color="themeInputColor"
					:loading="loadingUserDetails"
					@click="initiateTransferCoins"
					:disabled="!isPhoneNoValid"
					>Continue</v-btn
				>
				<v-btn class="btn rounded-pill" color="error" outline @click="closeModal"
					>Cancel</v-btn
				>
			</v-layout>
		</v-container>
		<v-container
			class="pa-4 container"
			v-if="!isUserDetailsFetched && isMojAgency"
		>
			<v-layout row class="mb-2">
				<v-flex>
					<v-select
						:items="searchOptions"
						item-text="value"
						item-value="key"
						label="Search User By*"
						placeholder="Search User By"
						class="body-1 text-field-wrapper pt-4"
						v-model="mojSearchOption"
						:value="mojSearchOption"
						required
					></v-select>
				</v-flex>
			</v-layout>
			<v-layout class="mb-2">
				<v-flex
					v-if="mojSearchOption === 'phoneNo'"
					class="text-field-wrapper py-1 px-1 mx-0"
				>
					<MazPhoneNumberInput
						v-model="phone"
						required
						default-country-code="IN"
						@update="updatePhoneNoMoj"
						show-code-on-list
					/>
				</v-flex>
				<v-flex
					v-if="mojSearchOption === 'email'"
					class="text-field-wrapper py-1 px-1 mx-0"
				>
					<v-text-field
						v-model="mojSearchValue"
						label="User Email*"
						placeholder="User Email"
						class="text-field-wrapper ma-0 pt-4"
					/>
				</v-flex>
				<v-flex
					v-if="mojSearchOption === 'handle'"
					class="text-field-wrapper py-1 px-1 mx-0"
				>
					<v-text-field
						v-model="mojSearchValue"
						label="User Handle*"
						placeholder="User Handle"
						class="text-field-wrapper ma-0 pt-4"
					/>
				</v-flex>
			</v-layout>
			<v-layout class="d-flex justify-space-between">
				<v-btn
					class="mx-0 mr-4 white--text btn rounded-pill"
					:color="themeInputColor"
					:loading="loadingUserDetails"
					@click="initiateTransferCoinsMoj"
					:disabled="!isInputValidMoj"
					>Continue</v-btn
				>
				<v-btn class="btn rounded-pill" color="error" outline @click="closeModal"
					>Cancel</v-btn
				>
			</v-layout>
		</v-container>
		<v-container class="pa-4 container" v-if="isUserDetailsFetched">
			<v-layout class="mb-2">
				<v-flex class="py-1 px-1 mx-0">
					<div class="user-card">
						<v-avatar color="primary" size="40">
							<img
								:src="_getImageSrc(userData.pic)"
								alt
								class="contain"
							/>
						</v-avatar>
						<div>
							<div class="productValue">{{ userData.name }}</div>
							<div class="productMoney">
								{{ userData.handle }}
							</div>
							<div class="phone">Ph: {{ userData.phoneNo }}</div>
						</div>
						<div class="divider">
							<div class="productValue text-right">
								{{
									isShareChatAgency
										? "Credit Balance"
										: "Balance"
								}}
							</div>
							<div class="amount text-right">
								{{
									isShareChatAgency
										? creditLeft
										: `₹${jeet11WalletBalance.toLocaleString()}`
								}}
							</div>
						</div>
					</div>
				</v-flex>
			</v-layout>
			<v-layout class="mt-2">
				<v-radio-group
					:color="themeInputColor"
					v-model="productId"
					class="pa-0 ma-0 w-full"
					column
				>
					<div
						v-for="product in sharechatProducts"
						:key="product.productId"
					>
						<v-radio
							:color="themeInputColor"
							:value="product.productId"
							class="my-2"
							:disabled="
								isShareChatAgency
									? isMojAgency
										? calculatePurchaseAmountMoj(product) >
										  creditLeft
										: product.monetaryValue > creditLeft
									: product.monetaryValue >
									  jeet11WalletBalance
							"
						>
							<template v-slot:label>
								<div class="d-flex w-full verCenteredChild">
									<div class="productWrapper">
										<div
											class="productValue"
											v-bind:class="{
												'text-disabled': isShareChatAgency
													? isMojAgency
														? calculatePurchaseAmountMoj(
																product
														  ) > creditLeft
														: product.monetaryValue >
														  creditLeft
													: product.monetaryValue >
													  jeet11WalletBalance
											}"
										>
											{{
												isMojAgency
													? `${product.creditAmount} ${product.creditCurrency}`
													: `${product.virtualCurrencyValue} Coins`
											}}
										</div>
										<div
											class="productMoney d-flex"
											v-bind:class="{
												'text-disabled': isShareChatAgency
													? isMojAgency
														? calculatePurchaseAmountMoj(
																product
														  ) > creditLeft
														: product.monetaryValue >
														  creditLeft
													: product.monetaryValue >
													  jeet11WalletBalance
											}"
										>
											{{
												isShareChatAgency
													? isMojAgency
														? `${calculatePurchaseAmountMoj(
																product
														  )} Credits`
														: `${product.monetaryValue} Credits`
													: `₹${product.monetaryValue}`
											}}
											<div
												class="mx-2 strikethrough"
												v-if="
													isMojAgency &&
														calculatePurchaseAmountMoj(
															product
														) !==
															product.purchaseAmount /
																100
												"
											>
												{{
													product.purchaseAmount / 100
												}}
												Credits
											</div>
										</div>
									</div>
									<div
										v-if="
											!isMojAgency &&
												productId === product.productId
										"
										class="setCoin"
									>
										<div
											class="minusButton allCenteredChild"
											@click="changeQuantity(-1)"
										>
											-
										</div>
										<div class="ml-3 mr-3">
											{{ quantity }}
										</div>
										<div
											class="plusButton allCenteredChild"
											@click="changeQuantity(1)"
										>
											+
										</div>
									</div>
								</div>
							</template>
						</v-radio>
					</div>
				</v-radio-group>
			</v-layout>
			<v-layout class="d-block">
				<div>
					<div class="text-center mb-4">
						<div class="productMoney fz-18">
							Amount Payable :
							{{
								isShareChatAgency
									? `${totalAmount} Credits`
									: `₹${totalAmount}`
							}}
						</div>
						<span class="productValue">
							( Total Coins:
							{{ totalCoins }} )
						</span>
					</div>
				</div>
			</v-layout>
			<v-layout mb-4>
				<v-flex xs12 md4 lg3 class="d-flex">
					<v-text-field
						label="Enter mPin"
						v-model="mPin"
						@keyup.enter="confirmAndPayToUser"
						class="text-field-wrapper pt-4"
						placeholder="* * * *"
						type="password"
					></v-text-field>
				</v-flex>
				<v-flex class="allCenteredChild">
					<v-btn
						outline
						:color="themeInputColor"
						small
						class="btn body-1"
						@click="forgetMpin()"
						>Set/Reset mPin ?</v-btn
					>
				</v-flex>
			</v-layout>
			<v-layout class="d-flex justify-space-between">
				<v-btn
					class="mx-0 mr-4 white--text btn rounded-pill"
					:color="themeInputColor"
					:loading="payingUser"
					@click="confirmAndPayToUser"
					:disabled="isButtonDisabled"
					>Confirm</v-btn
				>
				<v-btn class="btn rounded-pill" color="error" outline @click="closeModal"
					>Cancel</v-btn
				>
			</v-layout>
		</v-container>
	</div>
</template>

<script>
import { mapState } from "vuex";
import {
	SHOW_ALERT,
	TRANSFER_COINS_FETCH_USER_DATA,
	FETCH_PRODUCTS,
	TRANSFER_COINS_FETCH_USER_DATA_MOJ
} from "../../store/action-types";
import placeholderImage from "@/assets/thumbnail.jpeg";

export default {
	name: "TransferMoney",
	props: [
		"themeInputColor",
		"payingUser",
		"forgetMpin",
		"model",
		"sharechatProducts",
		"jeet11WalletBalance",
		"triggerTransferCoinDataReset",
		"creditLeft",
		"isShareChatAgency",
		"isMojAgency"
	],
	data() {
		return {
			phone: null,
			quantity: 1,
			formattedPhoneNo: null,
			isPhoneNoValid: false,
			isPhoneNoValidMoj: false,
			mPin: null,
			productId: null,
			isUserDetailsFetched: false,
			loadingUserDetails: false,
			placeholderImage,
			searchOptions: [
				{ key: "phoneNo", value: "Phone No" },
				{ key: "email", value: "Email" },
				{ key: "handle", value: "Handle" }
			],
			mojSearchOption: "phoneNo",
			mojSearchValue: ""
		};
	},
	computed: {
		...mapState({
			ACCESS_TOKEN: state => state.auth.ACCESS_TOKEN,
			userData: state => state.jeet11.transferCoinsUserData
		}),
		isButtonDisabled() {
			if (
				(this.isMojAgency
					? this.isInputValidMoj
					: this.isPhoneNoValid) &&
				this.productId &&
				this.mPin
			) {
				return false;
			}
			return true;
		},
		totalCoins() {
			if (this.productId) {
				const selectedProduct = (this.sharechatProducts || []).find(
					product => product.productId === this.productId
				);
				return (
					(this.isMojAgency
						? selectedProduct.creditAmount
						: selectedProduct.virtualCurrencyValue) * this.quantity
				);
			}
			return 0;
		},
		totalAmount() {
			if (this.productId) {
				const selectedProduct = (this.sharechatProducts || []).find(
					product => product.productId === this.productId
				);
				return (
					(this.isMojAgency
						? this.calculatePurchaseAmountMoj(selectedProduct)
						: selectedProduct.monetaryValue) * this.quantity
				);
			}
			return 0;
		},
		isInputValidMoj() {
			if (this.mojSearchOption === "phoneNo") {
				return this.isPhoneNoValidMoj;
			} else if (this.mojSearchValue) {
				return true;
			}
			return false;
		}
	},
	methods: {
		calculatePurchaseAmountMoj(product) {
			if (product.offers && product.offers.length > 0) {
				const offer = product.offers[0];
				const offerData = product.offersData[offer];
				return offerData.purchaseAmount / 100;
			}
			return product.purchaseAmount / 100;
		},
		_getImageSrc(str) {
			return str || placeholderImage;
		},
		resetData() {
			this.phone = null;
			this.productId = null;
			this.mPin = null;
			this.isUserDetailsFetched = false;
			this.isPhoneNoValid = false;
			this.isPhoneNoValidMoj = false;
			this.mojSearchValue = false;
		},
		closeModal() {
			this.resetData();
			this.$emit("CLOSE_MODAL", this.model);
		},
		updatePhoneNo({ isValid, e164 }) {
			this.isPhoneNoValid = isValid;
			this.formattedPhoneNo = (e164 || "").substr(1);
		},
		updatePhoneNoMoj({ isValid, e164 }) {
			this.isPhoneNoValidMoj = isValid;
			this.formattedPhoneNo = (e164 || "").substr(1);
		},
		confirmAndPayToUser() {
			this.$emit("CONFIRM_AND_PAY_TO_JEET11_USER", {
				productId: this.productId,
				phone: this.formattedPhoneNo,
				mPin: this.mPin,
				quantity: this.quantity,
				userId: this.userData.userId
			});
		},
		async initiateTransferCoinsMoj() {
			const payload = {
				fieldName: this.mojSearchOption,
				fieldValue:
					this.mojSearchOption === "phoneNo"
						? this.formattedPhoneNo
						: this.mojSearchValue
			};
			this.loadingUserDetails = true;
			this.$store
				.dispatch(TRANSFER_COINS_FETCH_USER_DATA_MOJ.dispatch, payload)
				.catch(error => {
					this.showAlert(error.message);
					this.closeModal();
				})
				.then(res => {
					if (Object.keys(res)) {
						const { phoneNo } = res;
						this.loadingUserDetails = false;
						this.fetchProducts(phoneNo, true);
					} else {
						this.loadingUserDetails = false;
					}
				});
		},
		async initiateTransferCoins() {
			const payload = {
				phoneNo: this.formattedPhoneNo
			};
			this.loadingUserDetails = true;
			this.$store
				.dispatch(TRANSFER_COINS_FETCH_USER_DATA.dispatch, payload)
				.catch(error => {
					this.showAlert(error.message);
					this.closeModal();
				})
				.then(res => {
					if (Object.keys(res)) {
						const { phoneNo } = res;
						this.loadingUserDetails = false;
						this.fetchProducts(phoneNo);
					} else {
						this.loadingUserDetails = false;
					}
				});
		},
		showAlert(message) {
			this.$store.dispatch(SHOW_ALERT.dispatch, {
				text: message
			});
		},
		changeQuantity(val) {
			if (val > 0 && this.isShareChatAgency) {
				if (
					this.calculateTotalAmount(this.quantity + val) >
					this.creditLeft
				)
					return;
			}
			if (this.quantity + val < 1 || this.quantity + val > 20) return;
			this.quantity += val;
		},
		calculateTotalAmount(quantity) {
			if (this.productId) {
				const selectedProduct = (this.sharechatProducts || []).find(
					product => product.productId === this.productId
				);
				return selectedProduct.monetaryValue * quantity;
			}
			return 0;
		},
		fetchProducts(phoneNo, isMojProducts = false) {
			if (!this.fetchingProducts) {
				this.fetchingProducts = true;
				const payload = {
					userPhoneNumber: phoneNo,
					isMojProducts
				};
				this.$store
					.dispatch(FETCH_PRODUCTS.dispatch, payload)
					.catch(() => {})
					.then(() => {
						this.fetchingProducts = false;
						this.isUserDetailsFetched = true;
					});
			}
		}
	},
	watch: {
		triggerTransferCoinDataReset: function() {
			this.resetData();
		},
		productId: function() {
			this.quantity = 1;
		}
	}
};
</script>

<style lang="scss" scoped>
.strikethrough {
	text-decoration: line-through;
}
.w-full {
	width: 100%;
}
.header {
	border-radius: 16px 16px 0 0;
	background-color: #edf0f7;
	color: #233b5d;
	font-weight: 500;
	font-size: 20px;
	line-height: 21px;
	padding: 1em;
	text-align: center;
	letter-spacing: 0.004em;
}
.productWrapper {
	display: flex;
	flex-direction: column;
}
.productValue {
	font-weight: 700;
	color: #000;
	font-size: 14px;
	width: 100px;
	overflow: hidden;
	text-overflow: ellipsis;
}
.productMoney {
	font-weight: 500;
	color: #16986a;
	font-size: 13px;
}
.user-card {
	display: grid;
	grid-template-columns: 40px auto auto;
	align-items: center;
	grid-gap: 10px;
	border: 1px solid #ebebeb;
	padding: 12px;
}
.phone {
	font-weight: 500;
	color: #000;
	font-size: 12px;
}
.container {
	max-width: 600px;
}
.amount {
	font-weight: 500;
	color: #16986a;
	font-size: 20px;
}
.text-disabled {
	color: grey;
}
.divider {
	border-left: 1px solid #ebebeb;
}
.text--white {
	color: #ffffff;
}
.setCoin {
	display: flex;
	align-items: center;
	justify-content: space-between;
	border: 1px solid #7b899e;
	border-radius: 12px;
	overflow: hidden;
	height: 32px;
}
.plusButton {
	background: #cde6da;
	transform: scale(1.2);
	flex-grow: 1;
	width: 40px;
	height: 100%;
}
.minusButton {
	background: #edf0f6;
	transform: scale(1.2);
	flex-grow: 1;
	width: 36px;
	height: 100%;
}
.fz-18 {
	font-size: 18px;
}
</style>
